import(/* webpackMode: "eager" */ "/codebuild/output/src1233391512/src/apps/raffle/src/app/error.tsx");
